import Vue from 'vue'
import Vuex from 'vuex'
import storage from 'local-storage-fallback'
import { uuid } from 'vue-uuid'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        loading: false,
        token: null,
        session_data: {
            user: null,
            register: null,
            staff: null,
            outlet: null,
            logo: null,
            install_id: null,
            currency: null,
        },
        store_is_offline: 0,
        install_id: null,
        launched_at: Date.now(),
        app_settings: {
            order_search_enabled: true,
            sound_enabled: true,
            collection_points: [],
            ignore_collection_points: true,
        },
        token_checked: false,
    },
    getters: {
        token_checked(state) {
            return state.token_checked
        },
        ignore_collection_points(state) {
            return state.app_settings.ignore_collection_points
        },
        collection_points(state) {
            return state.app_settings.collection_points
        },
        order_search_enabled(state) {
            return state.app_settings.order_search_enabled
        },
        sound_enabled(state) {
            return state.app_settings.sound_enabled
        },
        store_is_offline(state) {
            return state.store_is_offline
        },
        token(state) {
            return state.token
        },
        user(state) {
            if(state.session_data)
                return state.session_data.user
            else
                return null
        },
        register_id(state) {
            return state.session_data.register_id
        },
        staff_id(state) {
            return state.session_data.staff_id
        },
        client(state) {
            return state.session_data.client
        },
        outlet(state) {
            return state.session_data.outlet
        },
        logo(state) {
            return state.session_data.logo
        },
        partner_source(state) {
            return state.session_data.partner_source
        },
        colour_theme(state) {
            return state.session_data.colour_theme
        },
        currency(state) {
            return state.session_data.currency
        },
        loading(state) {
            return state.loading
        },
        install_id(state) {
            return state.install_id
        },
        launched_at(state) {
            return state.launched_at
        },
    },
    mutations: {
        hydrate(state) {
            const session_data = JSON.parse(storage.getItem('session_data'))
            const app_settings = JSON.parse(storage.getItem('app_settings'))
            const token = storage.getItem('token')
            if (session_data && token && app_settings) {
                state.session_data = session_data
                state.token = token
                state.app_settings = app_settings
            }
            const install_id = storage.getItem('install_id')
            if (install_id) state.install_id = install_id
            else this.commit('setInstallId', uuid.v4())
        },
        setStoreStatus(state, data) {
            state.store_is_offline = data
        },
        setLoading(state, data) {
            state.loading = data
        },
        setToken(state, data) {
            state.token = data
        },
        setTokenChecked(state, data) {
            state.token_checked = data
        },
        logout(state) {
            state.session_data = null
            state.token = null
        },
        configSession(state, data) {
            state.session_data = {
                ...data,
            }
            state.token_checked = true
        },
        setInstallId(state, data) {
            state.install_id = data
        },
        setSearchSetting(state, data){
            state.app_settings.order_search_enabled = data
        },
        setSoundSetting(state, data){
            state.app_settings.sound_enabled = data
        },
        setCollectionPoints(state, data){
            state.app_settings.collection_points = data
        },
        setIgnoreCollectionPoints(state, date){
            state.app_settings.ignore_collection_points = date
        }
    },
})

store.subscribe((mutation, state) => {
    // Persist token
    if (mutation.type == 'setToken') {
        storage.setItem('token', state.token)
    }

    // Persist user on configSession
    if (mutation.type == 'configSession') {
        storage.setItem('session_data', JSON.stringify(state.session_data))
    }

    // Invalidate token and clear storage on logout
    if (mutation.type == 'logout') {
        storage.removeItem('session_data')
        storage.removeItem('token')
        storage.removeItem('app_settings')
    }

    // Persist install ID
    if (mutation.type == 'setInstallId') {
        storage.setItem('install_id', state.install_id)
    }

    // Persist app settings
    if (['setSearchSetting', 'setSoundSetting', 'setCollectionPoints', 'setIgnoreCollectionPoints'].includes(mutation.type)) {
        storage.setItem('app_settings', JSON.stringify(state.app_settings))
    }
})

export default store
